const ProtocolType = {
  Article: 'article://',
  Plugin: 'plugin://',
  Coolapk: 'coolmarket://'
}

const ProtocolList = [
  {
    header: ProtocolType.Article,
    routerName: 'ArticleDetail'
  },
  {
    header: ProtocolType.Plugin,
    routerName: 'PluginDetail'
  },
  {
    header: ProtocolType.Coolapk,
    routerName: ''
  }
]

export {
  ProtocolList,
  ProtocolType
}
